import { Swiper } from 'swiper'
import { breakpointDown } from '../../utils/breakpoints'


let sliderCLass = '.categories-filter-slider'

if($(sliderCLass).length && breakpointDown('lg')) {
  let swiper = new Swiper(sliderCLass, {
    slidesPerView: "auto",
    spaceBetween: 8,
    freeMode: true,
  });
}
